import moment from 'moment';

/**
 * Форматирует длительность между двумя моментами времени
 * @param {moment.Moment|string} start - начало (Moment или строка 'DD.MM.YYYY HH:mm')
 * @param {moment.Moment|string} end   - конец  (Moment или строка 'DD.MM.YYYY HH:mm')
 * @returns {string} — "2 д 3 ч 15 мин" или "45 сек"
 */
export const formatDuration = (start, end) => {
  const s = typeof start === 'string' ? moment(start, 'DD.MM.YYYY HH:mm') : start;
  const e = typeof end === 'string' ? moment(end, 'DD.MM.YYYY HH:mm') : end;
  if (!s.isValid() || !e.isValid()) return '';

  const diff = moment.duration(e.diff(s));
  const days = Math.floor(diff.asDays());
  const hours = diff.hours();
  const minutes = diff.minutes();
  const seconds = diff.seconds();

  let result = '';
  if (days > 0) result += `${days} д `;
  if (hours > 0) result += `${hours} ч `;
  if (minutes > 0) {
    result += `${minutes} мин`;
  } else if (days === 0 && hours === 0) {
    result += `${seconds} сек`;
  }
  return result.trim() || '0 сек';
};
